/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Write-side representation of a legal identifier. `regionCode` is always optional at the
 * contract level; whether it is required, allowed, or forbidden depends on the chosen
 * `registrationNumberType` and is enforced server-side.
 * 
 * @export
 * @interface CompanyLegalIdentifierRequestItem
 */
export interface CompanyLegalIdentifierRequestItem {
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalIdentifierRequestItem
     */
    registrationNumberType: string;
    /**
     * Registration number value. Whitespace is stripped server-side.
     * @type {string}
     * @memberof CompanyLegalIdentifierRequestItem
     */
    registrationNumberValue: string;
    /**
     * ISO-3166 alpha-2 country code.
     * @type {string}
     * @memberof CompanyLegalIdentifierRequestItem
     */
    countryCode: string;
    /**
     * Sub-jurisdiction code (e.g. German Bezirk). Always-optional at the contract level;
     * backend validates whether it is required/allowed for the chosen identifier type.
     * 
     * @type {string}
     * @memberof CompanyLegalIdentifierRequestItem
     */
    regionCode?: string;
}

/**
 * Check if a given object implements the CompanyLegalIdentifierRequestItem interface.
 */
export function instanceOfCompanyLegalIdentifierRequestItem(value: object): value is CompanyLegalIdentifierRequestItem {
    if (!('registrationNumberType' in value) || value['registrationNumberType'] === undefined) return false;
    if (!('registrationNumberValue' in value) || value['registrationNumberValue'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CompanyLegalIdentifierRequestItemFromJSON(json: any): CompanyLegalIdentifierRequestItem {
    return CompanyLegalIdentifierRequestItemFromJSONTyped(json, false);
}

export function CompanyLegalIdentifierRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLegalIdentifierRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'registrationNumberType': json['registrationNumberType'],
        'registrationNumberValue': json['registrationNumberValue'],
        'countryCode': json['countryCode'],
        'regionCode': json['regionCode'] == null ? undefined : json['regionCode'],
    };
}

export function CompanyLegalIdentifierRequestItemToJSON(value?: CompanyLegalIdentifierRequestItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registrationNumberType': value['registrationNumberType'],
        'registrationNumberValue': value['registrationNumberValue'],
        'countryCode': value['countryCode'],
        'regionCode': value['regionCode'],
    };
}

